import script from "./ExamTestQuestionBodyWeb.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamTestQuestionBodyWeb.vue?vue&type=script&setup=true&lang=ts"

import "./ExamTestQuestionBodyWeb.vue?vue&type=style&index=0&id=2a1283c0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a1283c0"]])

export default __exports__